import React, { useEffect, useState } from 'react';
import database from '../config/FirbaseConfig';
import '../styles/BestMenu.css';
import '../styles/FeedbackForm.css';
import { useParams, useSearchParams } from "react-router-dom";
import cals from '../assets/icons/0 Calories.svg';
import Labels from '../components/Labels';
import Modal from "react-modal";
import notify from "../assets/audio/orderPlaced.mp3";

const BestMenu = ({ restaurantID, RestaurantDetails, menuObj, LabelsData, DietaryFilters, Dietary, setDietary, AddOns, cart, setCart, Ordering, Messages, NavigationSuggestions }) => {
    const { filtertype, filtervalue } = useParams();
    const [searchParams] = useSearchParams();
    const [Data, setData] = useState(null);
    const [expandedItem, setExpandedItem] = useState(null);
    const [expandedDetails, setExpandedDetails] = useState(true);
    const [itemFeedback, setItemFeedback] = useState({}); // State to handle feedback responses
    const [modalOpen, setModalOpen] = useState(false);
    const [modalFilter, setModalFilter] = useState(null);
    const Items = menuObj?.filter(
        (menuObjItems) =>
            menuObjItems?.Name === expandedItem?.Name &&
            menuObjItems.Price !== 0 &&
            menuObjItems.Price !== null &&
            menuObjItems.Price !== "" &&
            menuObjItems.Visible === true &&
            menuObjItems.Visible !== false
    );
    const [selectedValue, setSelectedValue] = useState("");
    const [selectedAddOns, setSelectedAddOns] = useState({});
    const [AdditionalNotes, setAdditionalNotes] = useState(null);
    const [count, setCount] = useState(0);
    const audio = new Audio(notify);
    const [favourits, setFavourits] = useState([]);
    const phoneNumber = '9324291794';
    const loading = false;

    const handleFilterClick = (filterObj) => {
        const key = filterObj.filter;

        // If something is already selected → unselect directly
        if (Dietary[key]) {
            const newState = { ...Dietary };
            delete newState[key];
            setDietary(newState);
            return;
        }

        // If only 1 option → auto-select it
        if (filterObj.subOptions.length === 1) {
            setDietary({
                ...Dietary,
                [key]: filterObj.subOptions[0],
            });
            return;
        }

        setModalFilter(filterObj);
    };

    useEffect(() => {
        const fetchFavourites = async () => {
            if (phoneNumber) {
                try {
                    const phoneKey = phoneNumber.replace("+", "");
                    const favsSnapshot = await database
                        .ref(`Users/${phoneKey}/${restaurantID}/Favourites`)
                        .once("value");
                    const favs = favsSnapshot.val() || [];
                    setFavourits(favs);
                } catch (error) {
                    console.error("Error fetching favourites:", error);
                    setFavourits([]);
                }
            } else {
                setFavourits([]);
            }
        };
        fetchFavourites();
    }, [phoneNumber, restaurantID]);

    const groupByNameWithVariants = (items) => {
        const grouped = {};

        items.forEach((item) => {
            const name = item.Name;
            const variant =
                item.Variant?.replace(item.Name, "")
                    .replace("(", "")
                    .replace(")", "")
                    .trim() || "";
            if (!grouped[name]) {
                grouped[name] = {
                    ...item,
                    Price: {},
                };
            }

            if (item.Price !== 0 && item.Visible === true && item.Available === true) {
                grouped[name].Price[
                    `${variant && variant !== ""
                        ? variant
                        : item.Variation !== ""
                            ? item.Variation
                            : item.Name
                    }`
                ] = item.Price;
            }
        });

        return Object.values(grouped).sort((a, b) => a.Rank - b.Rank);
    };

    const groupedAddOns = AddOns && Object.values(AddOns?.filter((curr) => curr?.Group && curr?.DisplayName && curr?.ItemsName)?.reduce((acc, curr) => {
        const key = curr.Group;
        if (!acc[key]) {
            acc[key] = {
                group: curr.Group,
                displayName: curr.DisplayName,
                groupMaxLimit: parseInt(curr.MaxGroupAddonLimit) || 1,
                groupMinLimit: parseInt(curr.MinGroupAddonLimit) || 0,
                items: [],
                AddOnGroupid: curr.AddOnGroupid,
            };
        }

        const currentMaxLimit = parseInt(curr.MaxGroupAddonLimit) || 1;
        const currentMinLimit = parseInt(curr.MinGroupAddonLimit) || 0;
        acc[key].groupMaxLimit = Math.max(
            acc[key].groupMaxLimit,
            currentMaxLimit
        );
        acc[key].groupMinLimit = Math.min(
            acc[key].groupMinLimit,
            currentMinLimit
        );

        acc[key].items.push({
            name: curr.ItemsName,
            minLimit: curr?.MinItemAddonLimit || 0,
            maxLimit: curr?.MaxItemAddonLimit || 1,
            groupMaxLimit: Math.max(acc[key].groupMaxLimit, currentMaxLimit),
            groupMinLimit: Math.min(acc[key].groupMinLimit, currentMinLimit),
            price: parseFloat(curr.Price) || 0,
            AddOnItemid: curr.AddOnItemid,
        });
        return acc;
    }, {})
    );

    const handleChange = (event) => {
        setSelectedValue(event.target.value);
        setSelectedAddOns({});
    };

    const handleAddOnChange = (groupKey, itemName, action) => {
        const group = groupedAddOns.find((g) => g.group === groupKey);
        if (!group) return;

        const currentGroup = selectedAddOns[groupKey] || {};
        const item = group.items.find((i) => i.name === itemName);
        if (!item) return;

        const currentQty = currentGroup[itemName] || 0;

        // --- 1️⃣ Handle Item Level Constraints ---
        if (action === "increase") {
            const total = Object.values(currentGroup).reduce((a, b) => a + b, 0);

            if (currentQty >= item.maxLimit) return; // item max
            if (total >= group.groupMaxLimit) return; // group max

            return setSelectedAddOns({
                ...selectedAddOns,
                [groupKey]: {
                    ...currentGroup,
                    [itemName]: currentQty + 1,
                },
            });
        }

        if (action === "decrease") {
            if (currentQty <= item.minLimit) return; // Can't go below item min
            const newQty = currentQty - 1;

            const updated = { ...currentGroup };
            if (newQty === 0) delete updated[itemName];
            else updated[itemName] = newQty;

            return setSelectedAddOns({
                ...selectedAddOns,
                [groupKey]: updated,
            });
        }

        // --- 2️⃣ Checkbox Mode (MaxItemLimit = 1) ---
        if (action === "toggle") {
            const isSelected = currentQty > 0;
            const total = Object.values(currentGroup).reduce((a, b) => a + b, 0);

            if (isSelected) {
                // unselect – but not below min group rule
                if (total <= group.groupMinLimit && total !== group.groupMaxLimit)
                    return;

                return setSelectedAddOns({
                    ...selectedAddOns,
                    [groupKey]: {
                        ...currentGroup,
                        [itemName]: 0,
                    },
                });
            }

            // trying to check an item
            if (total >= group.groupMaxLimit) return;

            return setSelectedAddOns({
                ...selectedAddOns,
                [groupKey]: {
                    ...currentGroup,
                    [itemName]: 1,
                },
            });
        }
    };

    const validateAddOnsForSelectedVariation = ({
        selectedValue,
        Items,
        groupedAddOns,
        selectedAddOns,
    }) => {
        const errors = [];

        // ✅ Find actual selected item / variation
        const selectedItem =
            Items.find((i) => i.Variant === selectedValue) ||
            Items.find((i) => i.Name === selectedValue);

        if (!selectedItem) {
            return { isValid: true, errors: [] };
        }

        // ✅ Add-on groups applicable to this variation
        const applicableGroups = Array.isArray(selectedItem["Add-Ons"])
            ? selectedItem["Add-Ons"]
            : [];

        // ✅ No add-ons applicable → valid
        if (applicableGroups.length === 0) {
            return { isValid: true, errors: [] };
        }

        groupedAddOns
            .filter((group) => applicableGroups.includes(group.group))
            .forEach((group) => {
                const selections = selectedAddOns[group.group] || {};

                // ✅ Total quantity in group
                const totalQty = Object.values(selections).reduce(
                    (sum, qty) => sum + (qty || 0),
                    0
                );

                // ✅ Group min
                if (group.groupMinLimit > 0 && totalQty < group.groupMinLimit) {
                    errors.push(
                        `Select at least ${group.groupMinLimit} item(s) in "${group.displayName}"`
                    );
                }

                // ✅ Group max
                if (group.groupMaxLimit > 0 && totalQty > group.groupMaxLimit) {
                    errors.push(
                        `You can select only ${group.groupMaxLimit} item(s) in "${group.displayName}"`
                    );
                }

                // ✅ Item-level rules
                group.items.forEach((item) => {
                    const qty = selections[item.name] || 0;

                    if (item.minLimit > 0 && qty < item.minLimit) {
                        errors.push(`"${item.name}" requires at least ${item.minLimit}`);
                    }

                    if (item.maxLimit > 0 && qty > item.maxLimit) {
                        errors.push(`"${item.name}" allows maximum ${item.maxLimit}`);
                    }
                });
            });

        return {
            isValid: errors.length === 0,
            errors,
        };
    };

    const AddToCart = async () => {
        if (loading) return;

        if (!phoneNumber) {
            alert("Login to place order.");
            window.location.reload();
            return;
        }

        if (selectedValue === "") {
            alert("Select a product variant to continue.");
            return;
        }

        if (count <= 0) {
            alert(
                "Oops! Can't proceed with zero quantity. Please choose how many you'd like to add."
            );
            return;
        }

        const { isValid, errors } = validateAddOnsForSelectedVariation({
            selectedValue,
            Items,
            groupedAddOns,
            selectedAddOns,
        });

        if (!isValid) {
            alert(errors.join("\n"));
            return;
        }

        let theItem = menuObj.find(
            (item) =>
                item.Variant === selectedValue ||
                (item.Name === selectedValue && !item.Variant)
        );

        const addOnsItemDetails = groupedAddOns.flatMap((group) => {
            const selections = selectedAddOns[group.group] || {};
            return group.items
                .filter((item) => selections[item.name] > 0)
                .map((item) => ({
                    Name: item.name,
                    Price: item.price,
                    Qty: selections[item.name],
                    Group: group.group,
                    GroupDisplayName: group.displayName,
                    Limit: group.groupMaxLimit,
                    AddOnGroupid: group.AddOnGroupid,
                    AddOnItemid: item.AddOnItemid,
                }));
        });

        let Amount = theItem.Price * count;

        addOnsItemDetails.forEach((addOn) => {
            Amount += addOn.Price * addOn.Qty * count;
        });

        const cartItem = {
            ...theItem,
            Qty: count,
            SelectedAddOns: addOnsItemDetails,
            AdditionalNotes,
            Amount,
        };

        setCart((prev) => {
            const updated = [...prev, cartItem];
            localStorage.setItem(`${restaurantID}_Cart`, JSON.stringify(updated));
            console.log("Cart updated:", updated);
            return updated;
        });

        // enable vibration support
        navigator.vibrate =
            navigator.vibrate ||
            navigator.webkitVibrate ||
            navigator.mozVibrate ||
            navigator.msVibrate;

        if (navigator.vibrate) {
            // vibration API supported
            navigator.vibrate(1000);
        }

        navigator.vibrate?.(150);
        audio?.play();

        audio.play();

        setSelectedValue("");
        setSelectedAddOns({});
        setAdditionalNotes(null);
        setCount(0);
        await window.gtag("event", `Added_To_Cart`, (prev) => {
            const updated = [...prev, cartItem];
            localStorage.setItem(`${restaurantID}_Cart`, JSON.stringify(updated));
            return updated;
        });
        alert("Item added to Cart successfully!");
        // window.location.reload();
    };

    // Handle auto-expansion of item from query parameter
    useEffect(() => {
        const expandItemParam = searchParams.get('expandItem');
        if (expandItemParam && Data) {
            const itemToExpand = Data.find(item => item.Name === decodeURIComponent(expandItemParam));
            if (itemToExpand) {
                setExpandedItem(itemToExpand);
                setExpandedDetails(true);
                // Scroll to the item after a small delay to ensure it's rendered
                setTimeout(() => {
                    const itemElement = document.getElementById(itemToExpand.Name);
                    if (itemElement) {
                        itemElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }, 100);
            }
        }
    }, [searchParams, Data]);

    useEffect(() => {
        try {
            const getData = async () => {
                if (!menuObj) return;

                const filteredData = Object.values(menuObj)?.filter(item => {
                    const field = item[decodeURI(filtertype)];
                    const value = decodeURI(filtervalue);

                    if (Array.isArray(field)) {
                        return field.includes(value);
                    } else {
                        return field === value;
                    }
                });

                const groupedData = groupByNameWithVariants(filteredData);
                setData(groupedData);
            };
            getData();
        }
        catch (error) {
            console.error("Error fetching data:", error);
            setData([]);
        }
    }, [filtertype, filtervalue, menuObj]);

    const BackButton = (e) => {
        const timestamp = new Date();
        window.gtag("event", `${e}_Click`, {
            timestamp: timestamp
                .toLocaleString("sv-SE", { timeZone: "Asia/Kolkata", hour12: false })
                .replace("T", " "),
            click: e,
        });
        if (window.history.length >= 1) {
            // There's something in the history stack to go back to
            window.history.back();
        } else {
            // No history, redirect to fallback
            window.location.href = "/"; // or "/dashboard", or any fallback route
        }
    };

    const openDetailedCard = (item) => {
        const timestamp = new Date();
        window.gtag("event", `${item.Name}_Card_Opened`, {
            timestamp: timestamp
                .toLocaleString("sv-SE", { timeZone: "Asia/Kolkata", hour12: false })
                .replace("T", " "),
            itemName: item.Name,
            itemDetails: item,
        });
        setExpandedDetails(true);

        if (item?.Name === expandedItem?.Name) {
            setExpandedItem(null);
            return;
        }

        setCount(1);
        setSelectedAddOns({});
        setAdditionalNotes(null);

        const relevantItems = menuObj?.filter(
            (menuObjItems) =>
                menuObjItems?.Name === item?.Name &&
                menuObjItems.Price !== 0 &&
                menuObjItems.Price !== null &&
                menuObjItems.Price !== "" &&
                menuObjItems.Visible === true &&
                menuObjItems.Visible !== false
        );

        if (relevantItems?.length === 1) {
            const option = relevantItems[0];
            setSelectedValue(option.Variant ? option.Variant : option.Name);
        } else {
            setSelectedValue("");
        }

        setExpandedItem(item);
    };

    const handleSubmit = (itemName) => {
        const unix = Date.now();
        const feedback = {
            ...itemFeedback[itemName],
            Name: itemName,
            timestamp: new Date()
                .toLocaleString("sv-SE", { timeZone: "Asia/Kolkata", hour12: false })
                .replace("T", " "),
            unix: unix,
        };
        if (itemFeedback[itemName]) {
            const timestamp = new Date();
            database.ref(`itemFeedback/${restaurantID}/${unix}`).set(feedback);
            window.gtag("event", `${itemName}_Feedback_Submitted`, {
                timestamp: timestamp
                    .toLocaleString("sv-SE", { timeZone: "Asia/Kolkata", hour12: false })
                    .replace("T", " "),
                feedback: feedback,
                From: "MenuCard",
            });
            alert("Feedback submitted successfully!");
            setExpandedItem(null);
            setItemFeedback({ ...itemFeedback, [itemName]: {} }); // Reset feedback for the item
        } else {
            alert("Please provide feedback before submitting.");
        }
    };

    const redirectTrigger = (e) => {
        const timestamp = new Date();
        // Track successful login event
        window.gtag("event", `${e}_Click`, {
            timestamp: timestamp
                .toLocaleString("sv-SE", { timeZone: "Asia/Kolkata", hour12: false })
                .replace("T", " "),
            click: e,
        });
        window.location.href = e;
    };

    const handleShare = async ({ title, desc, img }) => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: `${title}\n` || "R\n",
                    text: `\n${desc}\n` || "\nCheck out this amazing dish!\n",
                    url:
                        `${window.location.origin}/Product/Name/${encodeURIComponent(
                            title
                        )}` || "https://samudaya.ettarracoffee.com",
                });
                const timestamp = new Date();
                window.gtag("event", "product_share", {
                    timestamp: timestamp
                        .toLocaleString("sv-SE", {
                            timeZone: "Asia/Kolkata",
                            hour12: false,
                        })
                        .replace("T", " "),
                    event_category: "engagement",
                    event_label: title,
                    description: desc,
                    link: `${window.location.origin}/Product/Name/${encodeURIComponent(
                        title
                    )}`,
                });
                console.log("Shared successfully");
            } catch (err) {
                console.error("Error sharing:", err);
            }
        } else {
            alert("Sharing not supported on this browser");
        }
    };

    return (
        <div className="best-menu-container">
            <>
                <div className='best-menu-container-top' >
                    <div style={{
                        height: 'fit-content',
                        minHeight: "35px",
                        border: "0.75px solid #001E3A50",
                        borderRadius: '25px',
                        padding: "5px 25px",
                        fontSize: '14px',
                        lineHeight: '14px',
                        color: '#001E3A',
                        backgroundColor: '#FFFFFF',
                        margin: "0px 0px 0px 25px"
                    }}>
                        <svg xmlns="http://www.w3.org/2000/svg" onClick={() => BackButton('Back_Button')} height="21px" viewBox="0 -960 960 960" width="21px" fill="#001E3A">
                            <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
                        </svg>
                        &nbsp;|&nbsp;&nbsp;&nbsp;
                        {window.history.length >= 2 && (
                            <svg xmlns="http://www.w3.org/2000/svg" onClick={() => redirectTrigger(`/`)} height="25px" viewBox="0 -960 960 960" width="25px" fill="#001E3A"><path d="M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z" /></svg>
                        )}
                        &nbsp;&nbsp;&nbsp;|&nbsp;
                        <svg xmlns="http://www.w3.org/2000/svg" style={{ rotate: '180deg' }} onClick={() => setModalOpen(true)} height="21px" viewBox="0 -960 960 960" width="21px" fill="#001E3A">
                            <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
                        </svg>
                    </div>
                    <Labels LabelsData={LabelsData} />
                    <div className="best-menu-DietaryPrefRow">
                        <i>Dietary Preferences&nbsp;&nbsp;</i>

                        {DietaryFilters && Object.keys(DietaryFilters).map((filterName) => {

                            const filterObj = DietaryFilters?.[filterName];
                            const isSelected = !!Dietary?.[filterName];

                            return (
                                <div
                                    key={filterName}
                                    className={isSelected ? "best-menu-DietaryPrefSelected" : "best-menu-DietaryPref"}
                                    onClick={() => handleFilterClick(filterObj)}
                                >
                                    {filterName}
                                </div>
                            );
                        })}
                    </div>
                    {modalFilter && (
                        <Modal
                            isOpen={true}
                            onRequestClose={() => setModalFilter(null)}
                            style={{
                                overlay: {
                                    backgroundColor: "rgba(0,0,0,0.4)",
                                    zIndex: 9999,
                                },
                                content: {
                                    top: '50%',
                                    left: '50%',
                                    transform: "translate(-50%, -50%)",
                                    padding: "15px 10px 10px 10px",
                                    width: "fit-content",
                                    height: "fit-content",
                                    borderRadius: "25px",
                                    border: "1px solid #ccc",
                                    backgroundColor: "#FFFFFFF0",
                                    backdropFilter: "blur(10px)",
                                },
                            }}
                        >
                            <div>&nbsp;Select Preference</div>
                            {modalFilter.subOptions.map((opt) => (
                                <div
                                    key={opt}
                                    style={{
                                        width: "265px",
                                        padding: "10px",
                                        marginTop: "10px",
                                        borderRadius: "15px",
                                        background: Dietary[modalFilter.filter] === opt ? "#001E3A" : "#EFEFEF",
                                        color: Dietary[modalFilter.filter] === opt ? "#FFFFFF" : "#001E3A",
                                        cursor: "pointer",
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}
                                    onClick={() => {
                                        setDietary((prev) => {
                                            const newDiet = { ...prev };

                                            if (newDiet[modalFilter.filter] === opt) {
                                                // If clicking the same option again → clear it
                                                delete newDiet[modalFilter.filter];
                                            } else {
                                                // Otherwise set it
                                                newDiet[modalFilter.filter] = opt;
                                            }

                                            return newDiet;
                                        });

                                        setModalFilter(null);
                                    }}

                                >
                                    <div
                                        style={{
                                            width: "16px",
                                            height: "16px",
                                            borderRadius: "16px",
                                            border: Dietary[modalFilter.filter] === opt ? "3px solid white" : "1px solid #001E3A",
                                            background: Dietary[modalFilter.filter] === opt ? "#001E3A" : "transparent",
                                            boxSizing: "border-box",
                                        }}
                                    />&nbsp;{opt}
                                </div>
                            ))}
                            <div style={{ fontSize: '12px', lineHeight: '12px', margin: "12px 5px 5px 5px", color: '#001E3A' }}><i>Please notify our team at the time of ordering</i></div>
                        </Modal>
                    )}
                </div>
                <Modal
                    isOpen={modalOpen}
                    onRequestClose={() => setModalOpen(false)}
                    style={{
                        overlay: {
                            backgroundColor: "rgba(0,0,0,0.4)",
                            zIndex: 9999,
                        },
                        content: {
                            width: "94vw",
                            Height: "fit-content",
                            maxHeight: "70vh",
                            inset: "10vh 3vw 3vw 3vw",
                            borderRadius: "15px",
                            padding: "25px 0px",
                            overflowY: "auto",
                            position: "relative",
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "center",
                        },
                    }}
                >
                    <div className="NavigationSuggestions-container">
                        Go to:&nbsp;&nbsp;
                        {NavigationSuggestions && Object.keys(NavigationSuggestions).map((suggestion) => (
                            <div
                                key={suggestion}
                                className={`NavigationSuggestion ${`${decodeURI(filtertype)}/${decodeURI(filtervalue)}` ===
                                    NavigationSuggestions[suggestion].Link
                                    ? "currentNavigationSuggestion"
                                    : ""
                                    }`}
                                onClick={() =>
                                    `${decodeURI(filtertype)}/${decodeURI(filtervalue)}` !==
                                        NavigationSuggestions[suggestion].Link
                                        ? redirectTrigger(`/${NavigationSuggestions[suggestion].Link}`)
                                        : null
                                }
                            >
                                {NavigationSuggestions[suggestion].DisplayName}
                                {`${decodeURI(filtertype)}/${decodeURI(filtervalue)}` !==
                                    NavigationSuggestions[suggestion].Link ? (
                                    <>&nbsp;&nbsp;&gt;</>
                                ) : (
                                    <></>
                                )}
                            </div>
                        ))}
                    </div>
                </Modal>
                {Data ? (
                    Data.map(
                        (item) =>
                            item &&
                            item.Visible && (
                                <div key={`${item.Name}_${item.Variation}`}>
                                    {item && item.Visible && (
                                        <div
                                            key={`${item.Variant}_${item.Description}`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                openDetailedCard(item);
                                            }}
                                        >
                                            <div className="item-card" id={`${item.Name}`}>
                                                {" "}
                                                {/*onClick={() => openDetailedCard(item)}>*/}
                                                {item.Available === false ? (
                                                    <div
                                                        className="Unavailable"
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        Unavailable
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                                <div className="item-card-info">
                                                    <div className="item-labels-icons" style={{ display: 'flex', gap: '3px', flexWrap: 'wrap', marginBottom: '5px' }}>
                                                        {item['IsNew'] && <span className='item-top-labels-text'>New</span>}
                                                        {item['IsPopular'] && <span className='item-top-labels-text'>Popular</span>}
                                                        {item['IsBestSeller'] && <span className='item-top-labels-text'>Best Seller</span>}
                                                        {item['IsRecommended'] && <span className='item-top-labels-text'>Recommended</span>}
                                                    </div>
                                                    <div className="item-card-name">{item.Name}</div>
                                                    <div className="item-labels-icons">
                                                        {(item?.Dietary === "Veg" && <span className='css-label-icon-veg'>V</span>)}
                                                        {(item?.Dietary === "Non-Veg" && <span className='css-label-icon-nonveg'>NV</span>)}
                                                        {(item?.Dietary === "Egg" && <span className='css-label-icon-egg'>E</span>)}
                                                        {LabelsData?.filter(LabelsDataItem =>
                                                            item?.Labels.includes(LabelsDataItem?.['Label'])
                                                        ).map(filteredLabel => (
                                                            <img
                                                                key={filteredLabel?.Label || Date.now()}
                                                                src={filteredLabel?.URL}
                                                                alt={filteredLabel?.Label || 'label-icon'}
                                                                className="item-labels-icon"
                                                            />
                                                        ))}
                                                        {item?.['Custom Text Label'] && item?.['Custom Text Label'][0] && item['Custom Text Label'].map((labeltext) => (<span key={labeltext} className='item-labels-text-custom'>{labeltext}</span>))}
                                                        {item?.['KiloCalories'] && <><div style={{ height: '20px', fontSize: '11px', lineHeight: '20px', fontWeight: 600, textAnchor: 'middle', paddingLeft: '7px', color: '#FF0000' }}><img src={cals} alt='cals' className="item-labels-icon" />{item?.['KiloCalories']}</div></>}
                                                    </div>
                                                    {/* <div className="item-card-desc">{item.Description}</div> */}
                                                    {item.Name === expandedItem?.Name ? (
                                                        <div className="item-card-desc">
                                                            {item.Description}
                                                        </div>
                                                    ) : (
                                                        <div className="item-card-desc">
                                                            {item["Description"].length > 50
                                                                ? `${item.Description.slice(0, 50)} ...`
                                                                : item.Description}
                                                            {item["Description"].length > 50 && (
                                                                <span className="read-more">(Read more)</span>
                                                            )}
                                                        </div>
                                                    )}
                                                    {/* <div className="item-card-price">
                                        {Object.entries(item.Price).map(([size, price]) => (
                                            <div key={size} className="price-row">
                                                <span className="size">{size}</span> <span className="price">Rs. {price}</span>
                                            </div>
                                        ))}
                                    </div> */}
                                                    {(item.Name !== expandedItem?.Name) && (Object.keys(item.Price).length === 1) && (groupedAddOns?.filter((groupedAddOn) => menuObj?.[(menuObj?.findIndex((Item) => (Item?.Name === expandedItem?.Name)))]?.['Add-Ons'].includes(groupedAddOn?.group) ||
                                                        menuObj[(menuObj?.findIndex((Item) => (Item?.Variant === expandedItem?.Name)))]?.['Add-Ons'].includes(groupedAddOn?.group))?.length === 0) ? <div style={{ fontSize: '14px', fontWeight: 700, lineHeight: '16px', textAnchor: 'middle', color: '#333', textAlign: 'left', margin: '3px 0px' }}>{Object.keys(item.Price)[0]}{Object.keys(item.Price)[0] && ": "}{Object.values(item.Price)[0]}</div> : <>
                                                        <div className='view-price'><i>{item.Name !== expandedItem?.Name ? 'View' : 'Hide'} Option{Object.keys(item.Price).length > 1 ? 's' : ''}</i>
                                                        </div>
                                                    </>}
                                                </div>
                                                {Ordering?.['MenuOrdering'] === "Enable" ? (
                                                    <>
                                                        {
                                                            <div
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "130px",
                                                                    transform: "translateY(-15%)",
                                                                    left: "calc(92vw - 32.5px - 82px)",
                                                                    color: "#001E3A",
                                                                    backgroundColor: "#FFFFFFC0",
                                                                    backdropFilter: "blur(5px)",
                                                                    display: "flex",
                                                                    flexWrap: "wrap",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    width: "70px",
                                                                    height: "30px",
                                                                    fontSize: "14px",
                                                                    fontWeight: 600,
                                                                    cursor: "pointer",
                                                                    lineHeight: "25px",
                                                                    padding: "0px 0px 0px 5px",
                                                                    boxShadow: "0px 0px 10px #001E3A99",
                                                                    textAlign: "center",
                                                                    border: "0.5px solid #001E3A10",
                                                                    borderRadius: "10px",
                                                                }}
                                                            >
                                                                Add
                                                                {item.Name !== expandedItem?.Name ? (
                                                                    <div
                                                                        style={{
                                                                            position: "relative",
                                                                            width: "20px",
                                                                            height: "20px",
                                                                            top: "5px",
                                                                            left: "5px",
                                                                        }}
                                                                    >
                                                                        <svg
                                                                            style={{
                                                                                position: "absolute",
                                                                                width: "10px",
                                                                                height: "10px",
                                                                                top: "0px",
                                                                                left: "0.5px",
                                                                                transform: "translate(-50% -50%)",
                                                                                rotate: "0deg",
                                                                            }}
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="20"
                                                                            height="20"
                                                                            viewBox="0 0 20 20"
                                                                            fill="none"
                                                                        >
                                                                            <path
                                                                                d="M9.5 20V10.5M9.5 10.5V10M9.5 10.5H10M9.5 10.5H0"
                                                                                stroke="#001E3A"
                                                                            />
                                                                        </svg>
                                                                        <svg
                                                                            style={{
                                                                                position: "absolute",
                                                                                width: "10px",
                                                                                height: "10px",
                                                                                top: "0.5px",
                                                                                left: "0px",
                                                                                transform: "translate(-50% -50%)",
                                                                                rotate: "180deg",
                                                                            }}
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="20"
                                                                            height="20"
                                                                            viewBox="0 0 20 20"
                                                                            fill="none"
                                                                        >
                                                                            <path
                                                                                d="M9.5 20V10.5M9.5 10.5V10M9.5 10.5H10M9.5 10.5H0"
                                                                                stroke="#001E3A"
                                                                            />
                                                                        </svg>
                                                                    </div>
                                                                ) : (
                                                                    <div
                                                                        style={{
                                                                            position: "relative",
                                                                            width: "20px",
                                                                            height: "20px",
                                                                            top: "0px",
                                                                            left: "3px",
                                                                        }}
                                                                    >
                                                                        <svg
                                                                            style={{
                                                                                position: "absolute",
                                                                                width: "15px",
                                                                                height: "15px",
                                                                                top: "0px",
                                                                                left: "0px",
                                                                                transform: "translate(-50% -50%)",
                                                                                rotate: "-45deg",
                                                                            }}
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="20"
                                                                            height="20"
                                                                            viewBox="0 0 20 20"
                                                                            fill="none"
                                                                        >
                                                                            <path
                                                                                d="M9.5 20V10.5M9.5 10.5V10M9.5 10.5H10M9.5 10.5H0"
                                                                                stroke="#001E3A"
                                                                            />
                                                                        </svg>
                                                                        <svg
                                                                            style={{
                                                                                position: "absolute",
                                                                                width: "15px",
                                                                                height: "15px",
                                                                                top: "0px",
                                                                                left: "0px",
                                                                                transform: "translate(-50% -50%)",
                                                                                rotate: "315deg",
                                                                            }}
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="20"
                                                                            height="20"
                                                                            viewBox="0 0 20 20"
                                                                            fill="none"
                                                                        >
                                                                            <path
                                                                                d="M9.5 20V10.5M9.5 10.5V10M9.5 10.5H10M9.5 10.5H0"
                                                                                stroke="#001E3A"
                                                                            />
                                                                        </svg>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        }
                                                    </>
                                                ) : (
                                                    <>
                                                        {item.Name !== expandedItem?.Name ? (
                                                            <div
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "130px",
                                                                    translateY: "-50%",
                                                                    left: "calc(92vw - 32.5px - 72px)",
                                                                    width: "50px",
                                                                    height: "27px",
                                                                    background: "#FFFFFF",
                                                                    borderRadius: "70px",
                                                                    boxShadow: "0px 0px 7px #4F3C2B99",
                                                                    textAlign: "center",
                                                                    color: "#001E3A",
                                                                    rotate: "180deg",
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    openDetailedCard(item);
                                                                }}
                                                            >
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    height="27px"
                                                                    viewBox="0 -960 960 960"
                                                                    width="30px"
                                                                    fill="#001E3A"
                                                                >
                                                                    <path d="M480-528 296-344l-56-56 240-240 240 240-56 56-184-184Z" />
                                                                </svg>
                                                            </div>
                                                        ) : (
                                                            <div
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "130px",
                                                                    translateY: "-50%",
                                                                    left: "calc(92vw - 25px - 72px)",
                                                                    width: "35px",
                                                                    height: "27px",
                                                                    background: "#FFFFFF",
                                                                    borderRadius: "70px",
                                                                    boxShadow: "0px 0px 7px #4F3C2B99",
                                                                    textAlign: "center",
                                                                    color: "#001E3A",
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setExpandedItem(null);
                                                                }}
                                                            >
                                                                <svg
                                                                    style={{ rotate: "360deg" }}
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    height="27px"
                                                                    viewBox="0 -960 960 960"
                                                                    width="27px"
                                                                    fill="#001E3A"
                                                                >
                                                                    <path d="M480-528 296-344l-56-56 240-240 240 240-56 56-184-184Z" />
                                                                </svg>
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                                {item["Image"] &&
                                                    item["Image"] !== "" &&
                                                    item["Image"] !== null &&
                                                    item["Image"] !== "nan" ? (
                                                    <div className="item-card-img">
                                                        <img src={item["Image"]} alt={item.Name} />
                                                    </div>
                                                ) : (
                                                    <div
                                                        className="item-card-img"
                                                        style={{ boxShadow: "none" }}
                                                    ></div>
                                                )}
                                                {item["Image"] && (
                                                    <button
                                                        style={{
                                                            position: "absolute",
                                                            top: "20px",
                                                            right: "115px",
                                                            borderRadius: "15px",
                                                            border: "0px",
                                                            width: "24px",
                                                            height: "24px",
                                                            padding: "0px",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            display: "flex",
                                                            backgroundColor: "#00000055",
                                                            boxShadow: "inset 0px 0px 10px #0000035",
                                                        }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleShare({
                                                                title: item.Name,
                                                                desc: item.Description,
                                                                img: item["Image"],
                                                            });
                                                        }}
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            height="14px"
                                                            viewBox="0 -960 960 960"
                                                            width="14px"
                                                            fill="#FFFFFF"
                                                        >
                                                            <path
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                d="M251.78-32.39q-42.24 0-71.62-29.38-29.38-29.38-29.38-71.62v-393.56q0-42.25 29.38-71.63 29.38-29.38 71.62-29.38H354.5v101.01H251.78v393.56h456.44v-393.56H605.5v-101.01h102.72q42.24 0 71.62 29.38 29.38 29.38 29.38 71.63v393.56q0 42.24-29.38 71.62-29.38 29.38-71.62 29.38H251.78ZM429.5-307.72v-426.21l-65 65-70.59-71.03L480-926.61l186.09 186.65-70.59 71.03-65-65v426.21h-101Z"
                                                            />
                                                        </svg>
                                                    </button>
                                                )}
                                                <button
                                                    style={{
                                                        position: "absolute",
                                                        top: "20px",
                                                        right: "20px",
                                                        borderRadius: "15px",
                                                        border: "0px",
                                                        width: "24px",
                                                        height: "24px",
                                                        padding: "2px 0px 0px 0px",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        backgroundColor: favourits.includes(item.Name)
                                                            ? "#00000025"
                                                            : "#00000055",
                                                        boxShadow: "inset 0px 0px 10px #0000035",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={async (e) => {
                                                        e.stopPropagation();
                                                        const updatedFavs = favourits.includes(item.Name)
                                                            ? favourits.filter((fav) => fav !== item.Name)
                                                            : [...favourits, item.Name];
                                                        if (!phoneNumber) {
                                                            alert("Login to save favourites.");
                                                            return;
                                                        }
                                                        await database
                                                            .ref(
                                                                `Users/${phoneNumber.replace("+", "")}/${restaurantID}/Favourites`
                                                            )
                                                            .set(updatedFavs);

                                                        setFavourits(updatedFavs);
                                                    }}
                                                >
                                                    {favourits.includes(item.Name) ? (
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            height="20px"
                                                            viewBox="0 -960 960 960"
                                                            width="20px"
                                                            fill="#FF0000"
                                                        >
                                                            <path d="m480-144-50-45q-100-89-165-152.5t-102.5-113Q125-504 110.5-545T96-629q0-89 61-150t150-61q49 0 95 21t78 59q32-38 78-59t95-21q89 0 150 61t61 150q0 43-14 83t-51.5 89q-37.5 49-103 113.5T528-187l-48 43Z" />
                                                        </svg>
                                                    ) : (
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            height="20px"
                                                            viewBox="0 -960 960 960"
                                                            width="20px"
                                                            fill="#fff"
                                                        >
                                                            <path d="m480-144-50-45q-100-89-165-152.5t-102.5-113Q125-504 110.5-545T96-629q0-89 61-150t150-61q49 0 95 21t78 59q32-38 78-59t95-21q89 0 150 61t61 150q0 43-14 83t-51.5 89q-37.5 49-103 113.5T528-187l-48 43Zm0-97q93-83 153-141.5t95.5-102Q764-528 778-562t14-67q0-59-40-99t-99-40q-35 0-65.5 14.5T535-713l-35 41h-40l-35-41q-22-26-53.5-40.5T307-768q-59 0-99 40t-40 99q0 33 13 65.5t47.5 75.5q34.5 43 95 102T480-241Zm0-264Z" />
                                                        </svg>
                                                    )}
                                                </button>
                                                {
                                                    item.Name === expandedItem?.Name ? (
                                                        <>
                                                            <div className={`item-card-expanded-tabs`}>
                                                                <div
                                                                    className={`item-card-expanded-tab ${expandedDetails
                                                                        ? "item-card-expanded-tab-active"
                                                                        : ""
                                                                        }`}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setExpandedDetails(true);
                                                                    }}
                                                                >
                                                                    Details
                                                                </div>
                                                                <div
                                                                    className={`item-card-expanded-tab ${!expandedDetails
                                                                        ? "item-card-expanded-tab-active"
                                                                        : ""
                                                                        }`}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setExpandedDetails(false);
                                                                    }}
                                                                >
                                                                    Share Feedback
                                                                </div>
                                                            </div>
                                                            {expandedDetails ? (
                                                                <>
                                                                    <div
                                                                        className="item-card-price"
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        <div className="item-card-expanded-details">
                                                                            Option
                                                                            {Object.keys(item.Price).length > 1
                                                                                ? "s"
                                                                                : ""}
                                                                        </div>
                                                                        <span
                                                                            style={{
                                                                                fontSize: "10px",
                                                                                lineHeight: "10px",
                                                                                height: "10px",
                                                                                margin: "0px 5px",
                                                                                color: "#999",
                                                                            }}
                                                                        >
                                                                            {Object.keys(item.Price).length > 1
                                                                                ? "Select Any 1"
                                                                                : "Select"}
                                                                        </span>
                                                                        {Items.filter(
                                                                            (Item) =>
                                                                                Item.Price !== 0 &&
                                                                                Item.Price !== null &&
                                                                                Item.Price !== "" &&
                                                                                Item.Visible === true &&
                                                                                Item.Visible !== false
                                                                        ).map((option) => (
                                                                            <div
                                                                                key={
                                                                                    option.Variant
                                                                                        ? option.Variant
                                                                                        : option.Name
                                                                                }
                                                                                style={{
                                                                                    display: "grid",
                                                                                    gridTemplateColumns: "50vw 10vw",
                                                                                    margin: "10px 5px",
                                                                                    justifyContent: "space-between",
                                                                                    alignContent: "center",
                                                                                    alignItems: "center",
                                                                                    fontSize: "14px",
                                                                                    fontWeight: 500,
                                                                                    lineHeight: "18px",
                                                                                    textAnchor: "middle",
                                                                                    color: "#555",
                                                                                    padding: "3px 0px",
                                                                                }}
                                                                            >
                                                                                <label
                                                                                    key={
                                                                                        option.Variant
                                                                                            ? option.Variant
                                                                                            : option.Name
                                                                                    }
                                                                                >
                                                                                    {option.Variant
                                                                                        ? option.Variant
                                                                                        : option.Name}
                                                                                    &nbsp;
                                                                                    <span
                                                                                        style={{
                                                                                            fontSize: "14px",
                                                                                            fontWeight: 600,
                                                                                            lineHeight: "18px",
                                                                                            textAnchor: "middle",
                                                                                            color: "#999",
                                                                                        }}
                                                                                    >
                                                                                        {option?.Price > 0
                                                                                            ? `(${option.Price})`
                                                                                            : ""}
                                                                                    </span>
                                                                                </label>
                                                                                {Ordering?.['MenuOrdering'] === "Enable" && <input
                                                                                    type="radio"
                                                                                    name={
                                                                                        option.Variant
                                                                                            ? option.Variant
                                                                                            : option.Name
                                                                                    }
                                                                                    value={
                                                                                        option.Variant
                                                                                            ? option.Variant
                                                                                            : option.Name
                                                                                    }
                                                                                    checked={
                                                                                        selectedValue ===
                                                                                        (option.Variant
                                                                                            ? option.Variant
                                                                                            : option.Name)
                                                                                    }
                                                                                    onChange={(e) => handleChange(e)}
                                                                                    style={{
                                                                                        width: "25px",
                                                                                        height: "25px",
                                                                                        accentColor: "#001E3A",
                                                                                        alignSelf: "flex-end",
                                                                                        justifySelf: "end",
                                                                                        marginRight: "15px",
                                                                                    }}
                                                                                />}
                                                                            </div>
                                                                        ))}
                                                                        {Ordering?.['MenuOrdering'] === "Enable"
                                                                            ? groupedAddOns
                                                                                ?.filter(
                                                                                    (groupedAddOn) =>
                                                                                        Items[
                                                                                            Items.findIndex(
                                                                                                (Item) =>
                                                                                                    Item.Name === selectedValue
                                                                                            )
                                                                                        ]?.["Add-Ons"].includes(
                                                                                            groupedAddOn.group
                                                                                        ) ||
                                                                                        Items[
                                                                                            Items.findIndex(
                                                                                                (Item) =>
                                                                                                    Item.Variant ===
                                                                                                    selectedValue
                                                                                            )
                                                                                        ]?.["Add-Ons"].includes(
                                                                                            groupedAddOn.group
                                                                                        )
                                                                                )
                                                                                .map((group) => (
                                                                                    <div
                                                                                        key={group.group}
                                                                                        style={{
                                                                                            width: "calc(92vw - 30px)",
                                                                                            borderRadius: "15px",
                                                                                            marginTop: "15px",
                                                                                        }}
                                                                                    >
                                                                                        <div className="item-card-expanded-details">
                                                                                            {group.displayName}
                                                                                        </div>
                                                                                        <span
                                                                                            style={{
                                                                                                fontSize: "10px",
                                                                                                fontWeight:
                                                                                                    selectedAddOns?.[
                                                                                                        group?.group
                                                                                                    ] &&
                                                                                                        Object.values(
                                                                                                            selectedAddOns?.[
                                                                                                            group?.group
                                                                                                            ]
                                                                                                        ).reduce(
                                                                                                            (a, b) => a + b,
                                                                                                            0
                                                                                                        ) >= group?.groupMaxLimit
                                                                                                        ? 700
                                                                                                        : "normal",
                                                                                                lineHeight: "10px",
                                                                                                height: "10px",
                                                                                                margin: "0px 5px",
                                                                                                color:
                                                                                                    selectedAddOns?.[
                                                                                                        group?.group
                                                                                                    ] &&
                                                                                                        Object.values(
                                                                                                            selectedAddOns?.[
                                                                                                            group?.group
                                                                                                            ]
                                                                                                        ).reduce(
                                                                                                            (a, b) => a + b,
                                                                                                            0
                                                                                                        ) >= group?.groupMaxLimit
                                                                                                        ? "#555"
                                                                                                        : "#999",
                                                                                            }}
                                                                                        >
                                                                                            {group.groupMinLimit ===
                                                                                                group.groupMaxLimit
                                                                                                ? `Choose Any ${group.groupMinLimit}`
                                                                                                : group.groupMinLimit === 0
                                                                                                    ? `Choose up to ${group.groupMaxLimit}`
                                                                                                    : `Choose ${group.groupMinLimit} - ${group.groupMaxLimit}`}
                                                                                        </span>
                                                                                        {/* <hr style={{ height: '1px', margin: '3px 0px 10px 0px', color: '#999' }} /> */}
                                                                                        {group.items.map((item) => {
                                                                                            const currentSelections =
                                                                                                selectedAddOns[group.group] ||
                                                                                                {};
                                                                                            const addOnQty =
                                                                                                currentSelections?.[
                                                                                                item.name
                                                                                                ] || 0;

                                                                                            const totalInGroup =
                                                                                                Object.values(
                                                                                                    currentSelections
                                                                                                ).reduce((a, b) => a + b, 0);
                                                                                            const isCheckbox =
                                                                                                item.maxLimit === 1;

                                                                                            const isDisabled = (() => {
                                                                                                // Current total
                                                                                                const total = totalInGroup;

                                                                                                // If checkbox mode
                                                                                                if (isCheckbox) {
                                                                                                    // If box is NOT selected & group max is reached → disable
                                                                                                    return (
                                                                                                        addOnQty === 0 &&
                                                                                                        total >=
                                                                                                        group.groupMaxLimit
                                                                                                    );
                                                                                                }

                                                                                                // Button mode
                                                                                                // If group max reached → disable increase button
                                                                                                return (
                                                                                                    total >= group.groupMaxLimit
                                                                                                );
                                                                                            })();

                                                                                            return (
                                                                                                <div
                                                                                                    key={item.name}
                                                                                                    style={{
                                                                                                        display: "grid",
                                                                                                        gridTemplateColumns:
                                                                                                            "45vw 21vw",
                                                                                                        margin: "15px 5px",
                                                                                                        justifyContent:
                                                                                                            "space-between",
                                                                                                    }}
                                                                                                >
                                                                                                    <label
                                                                                                        style={{
                                                                                                            fontSize: "14px",
                                                                                                            fontWeight: 500,
                                                                                                            lineHeight: "18px",
                                                                                                            textAnchor: "middle",
                                                                                                            color: "#555",
                                                                                                            padding: "3px 0px",
                                                                                                        }}
                                                                                                    >
                                                                                                        {item.name}{" "}
                                                                                                        <span
                                                                                                            style={{
                                                                                                                fontSize: "14px",
                                                                                                                fontWeight: 600,
                                                                                                                lineHeight: "18px",
                                                                                                                textAnchor: "middle",
                                                                                                                color: "#777",
                                                                                                            }}
                                                                                                        >
                                                                                                            {item?.price > 0
                                                                                                                ? `(${item.price})`
                                                                                                                : ""}
                                                                                                        </span>
                                                                                                    </label>
                                                                                                    {item?.maxLimit > 1 ? (
                                                                                                        <div
                                                                                                            style={{
                                                                                                                display: "flex",
                                                                                                                alignItems: "center",
                                                                                                                boxShadow: isDisabled
                                                                                                                    ? "0px 0px 1px #001E3A75"
                                                                                                                    : "0px 0px 5px #001E3A45",
                                                                                                                borderRadius: "25px",
                                                                                                                width: "21vw",
                                                                                                                height: "25px",
                                                                                                                justifyContent:
                                                                                                                    "center",
                                                                                                                overflow: "hidden",
                                                                                                                alignSelf: "flex-end",
                                                                                                                justifySelf: "end",
                                                                                                                marginRight: "15px",
                                                                                                                backgroundColor:
                                                                                                                    isDisabled
                                                                                                                        ? "#EFEFEF"
                                                                                                                        : "#FFFFFF",
                                                                                                            }}
                                                                                                        >
                                                                                                            <div
                                                                                                                style={{
                                                                                                                    width: "7vw",
                                                                                                                    height: "25px",
                                                                                                                    textAlign: "center",
                                                                                                                    fontSize: "16px",
                                                                                                                    fontWeight: 700,
                                                                                                                    lineHeight: "25px",
                                                                                                                }}
                                                                                                                onClick={() =>
                                                                                                                    handleAddOnChange(
                                                                                                                        group.group,
                                                                                                                        item.name,
                                                                                                                        "decrease"
                                                                                                                    )
                                                                                                                }
                                                                                                                disabled={isDisabled}
                                                                                                            >
                                                                                                                &#45;
                                                                                                            </div>
                                                                                                            <div
                                                                                                                style={{
                                                                                                                    width: "7vw",
                                                                                                                    height: "25px",
                                                                                                                    textAlign: "center",
                                                                                                                    fontSize: "14px",
                                                                                                                    fontWeight:
                                                                                                                        "normal",
                                                                                                                    lineHeight: "25px",
                                                                                                                }}
                                                                                                            >
                                                                                                                {addOnQty || 0}
                                                                                                            </div>
                                                                                                            <div
                                                                                                                style={{
                                                                                                                    width: "7vw",
                                                                                                                    height: "25px",
                                                                                                                    textAlign: "center",
                                                                                                                    fontSize: "16px",
                                                                                                                    fontWeight: 700,
                                                                                                                    lineHeight: "25px",
                                                                                                                }}
                                                                                                                onClick={() =>
                                                                                                                    handleAddOnChange(
                                                                                                                        group.group,
                                                                                                                        item.name,
                                                                                                                        "increase"
                                                                                                                    )
                                                                                                                }
                                                                                                                disabled={isDisabled}
                                                                                                            >
                                                                                                                &#x2B;
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    ) : (
                                                                                                        <input
                                                                                                            type="checkbox"
                                                                                                            checked={
                                                                                                                (addOnQty &&
                                                                                                                    addOnQty > 0) ||
                                                                                                                false
                                                                                                            }
                                                                                                            disabled={isDisabled}
                                                                                                            onChange={() =>
                                                                                                                handleAddOnChange(
                                                                                                                    group.group,
                                                                                                                    item.name,
                                                                                                                    "toggle"
                                                                                                                )
                                                                                                            }
                                                                                                            style={{
                                                                                                                width: "10vw",
                                                                                                                height: "25px",
                                                                                                                accentColor:
                                                                                                                    "#EFEFEF",
                                                                                                                alignSelf: "flex-end",
                                                                                                                justifySelf: "end",
                                                                                                                marginRight: "15px",
                                                                                                            }}
                                                                                                        />
                                                                                                    )}
                                                                                                </div>
                                                                                            );
                                                                                        })}
                                                                                    </div>
                                                                                ))
                                                                            : groupedAddOns
                                                                                ?.filter(
                                                                                    (groupedAddOn) =>
                                                                                        menuObj?.[
                                                                                            menuObj?.findIndex(
                                                                                                (Item) =>
                                                                                                    Item?.Name === selectedValue
                                                                                            )
                                                                                        ]?.["Add-Ons"].includes(
                                                                                            groupedAddOn?.group
                                                                                        ) ||
                                                                                        menuObj[
                                                                                            menuObj?.findIndex(
                                                                                                (Item) =>
                                                                                                    Item?.Variant ===
                                                                                                    selectedValue
                                                                                            )
                                                                                        ]?.["Add-Ons"].includes(
                                                                                            groupedAddOn?.group
                                                                                        )
                                                                                )
                                                                                ?.map((group) => (
                                                                                    <div
                                                                                        key={group.group}
                                                                                        style={{
                                                                                            width: "calc(90vw - 30px)",
                                                                                            padding: "10px 0px",
                                                                                            borderRadius: "15px",
                                                                                            marginTop: "5px",
                                                                                        }}
                                                                                    >
                                                                                        <div className="item-card-expanded-details">
                                                                                            {group.displayName}
                                                                                        </div>
                                                                                        {group?.items?.map((item) => {
                                                                                            return (
                                                                                                <div
                                                                                                    key={item.name}
                                                                                                    style={{
                                                                                                        fontSize: "14px",
                                                                                                        fontWeight: 500,
                                                                                                        lineHeight: "18px",
                                                                                                        textAnchor: "middle",
                                                                                                        color: "#555",
                                                                                                        display: "grid",
                                                                                                        gridTemplateColumns:
                                                                                                            "50vw 20vw",
                                                                                                        margin:
                                                                                                            "10px 5px 0px 5px",
                                                                                                        justifyContent:
                                                                                                            "space-between",
                                                                                                        borderTop:
                                                                                                            "1px solid #efefef",
                                                                                                        paddingTop: "10px",
                                                                                                    }}
                                                                                                >
                                                                                                    <label>{item.name} </label>
                                                                                                    <span
                                                                                                        style={{
                                                                                                            fontSize: "14px",
                                                                                                            fontWeight: 500,
                                                                                                            lineHeight: "18px",
                                                                                                            textAnchor: "middle",
                                                                                                            color: "#555",
                                                                                                            padding: "3px 0px",
                                                                                                            textAlign: "right",
                                                                                                        }}
                                                                                                    >
                                                                                                        {item?.price > 0
                                                                                                            ? `${item.price}`
                                                                                                            : ""}
                                                                                                    </span>
                                                                                                </div>
                                                                                            );
                                                                                        })}
                                                                                    </div>
                                                                                ))}
                                                                        {Ordering?.['MenuOrdering'] === "Enable" && (
                                                                            <div
                                                                                style={{
                                                                                    width: "calc(92vw - 30px)",
                                                                                    borderRadius: "15px",
                                                                                    marginTop: "15px",
                                                                                }}
                                                                            >
                                                                                <div className="item-card-expanded-details">
                                                                                    Additional Notes
                                                                                </div>
                                                                                <textarea
                                                                                    style={{
                                                                                        width: "calc(92vw - 30px)",
                                                                                        height: "100px",
                                                                                        padding: "10px",
                                                                                        backgroundColor: "#f0f0f0",
                                                                                        borderRadius: "15px",
                                                                                        border: "0px",
                                                                                    }}
                                                                                    onChange={(e) => {
                                                                                        setAdditionalNotes(e.target.value);
                                                                                    }}
                                                                                ></textarea>
                                                                            </div>
                                                                        )}

                                                                        {Ordering?.['MenuOrdering'] === "Enable" && (
                                                                            <div
                                                                                style={{
                                                                                    display: "grid",
                                                                                    gridTemplateColumns:
                                                                                        "15vw 15vw 15vw calc(45vw - 30px)",
                                                                                    width: "calc(92vw - 30px)",
                                                                                    height: "60px",
                                                                                    margin: "10px 0px 5px 0px",
                                                                                    padding: "0px",
                                                                                    boxShadow: "1px 1px 10px #001E3A25",
                                                                                    borderRadius: "40px",
                                                                                    alignItems: "center",
                                                                                    textAlign: "center",
                                                                                    fontSize: "24px",
                                                                                    fontWeight: 600,
                                                                                }}
                                                                            >
                                                                                <div
                                                                                    onClick={() =>
                                                                                        count > 1 && setCount(count - 1)
                                                                                    }
                                                                                >
                                                                                    &#45;
                                                                                </div>
                                                                                <div>{count}</div>
                                                                                <div
                                                                                    onClick={() =>
                                                                                        count < 50 && setCount(count + 1)
                                                                                    }
                                                                                >
                                                                                    &#x2B;
                                                                                </div>
                                                                                <div
                                                                                    style={{
                                                                                        float: "right",
                                                                                        display: "flex",
                                                                                        flexWrap: "wrap",
                                                                                        width: "calc(45vw - 30px)",
                                                                                        height: "45px",
                                                                                        justifyContent: "center",
                                                                                        alignItems: "center",
                                                                                        textAlign: "center",
                                                                                        borderRadius: "45px",
                                                                                        fontSize: "14px",
                                                                                        fontWeight: 600,
                                                                                        lineHeight: "18px",
                                                                                        backgroundColor: "#001E3A",
                                                                                        color: "#fff",
                                                                                        cursor: "pointer",
                                                                                    }}
                                                                                    onClick={() => AddToCart()}
                                                                                >
                                                                                    Add to Cart
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="item-card-expanded">
                                                                        <label className="feedback-form-question">
                                                                            How much do you like this item?
                                                                        </label>
                                                                        <div
                                                                            className="feedback-form-checkbox-group"
                                                                            onClick={(e) => e.stopPropagation()}
                                                                        >
                                                                            {[1, 2, 3, 4, 5].map((value) => (
                                                                                <label key={value}>
                                                                                    <input
                                                                                        className="checkbox-label"
                                                                                        type="radio"
                                                                                        name={`question${expandedItem.Name}`}
                                                                                        value={value}
                                                                                        checked={
                                                                                            itemFeedback[expandedItem.Name]
                                                                                                ?.Score === value
                                                                                        }
                                                                                        onChange={(e) =>
                                                                                            setItemFeedback({
                                                                                                ...itemFeedback,
                                                                                                [expandedItem.Name]: {
                                                                                                    ...(itemFeedback[
                                                                                                        expandedItem.Name
                                                                                                    ] || {}),
                                                                                                    Score: parseInt(
                                                                                                        e.target.value
                                                                                                    ),
                                                                                                },
                                                                                            })
                                                                                        }
                                                                                    />
                                                                                    <span>{value}</span>
                                                                                </label>
                                                                            ))}
                                                                        </div>
                                                                        <label className="feedback-form-question">
                                                                            Additional Feedback Comments:
                                                                        </label>
                                                                        <textarea
                                                                            placeholder="Your answer"
                                                                            className="feedback-form-textarea"
                                                                            value={
                                                                                itemFeedback[expandedItem.Name]
                                                                                    ?.Comment || ""
                                                                            }
                                                                            onChange={(e) =>
                                                                                setItemFeedback({
                                                                                    ...itemFeedback,
                                                                                    [expandedItem.Name]: {
                                                                                        ...(itemFeedback[
                                                                                            expandedItem.Name
                                                                                        ] || {}),
                                                                                        Comment: e.target.value,
                                                                                    },
                                                                                })
                                                                            }
                                                                            onClick={(e) => e.stopPropagation()}
                                                                        />
                                                                        <button
                                                                            className="feedback-form-submit"
                                                                            onClick={() =>
                                                                                handleSubmit(expandedItem.Name)
                                                                            }
                                                                        >
                                                                            Submit
                                                                        </button>
                                                                    </div>
                                                                    <br />
                                                                    <div
                                                                        style={{
                                                                            fontSize: "20px",
                                                                            lineHeight: "25px",
                                                                            fontWeight: 700,
                                                                            width: "70vw",
                                                                            textAlign: "center",
                                                                            letterSpacing: "-5px",
                                                                            margin: "5px 5vw 0px 5vw",
                                                                            color: "#001E3A",
                                                                        }}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setExpandedItem(null);
                                                                        }}
                                                                    >
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            height="30px"
                                                                            viewBox="0 -960 960 960"
                                                                            width="30px"
                                                                            fill="#001E3A"
                                                                        >
                                                                            <path d="M480-528 296-344l-56-56 240-240 240 240-56 56-184-184Z" />
                                                                        </svg>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <></>
                                                    )
                                                    // <div style={{ width: '10vw', height: 'fit-content', textAlign: 'center', letterSpacing: '-5px', color: '#001E3A', rotate: '180deg' }} onClick={(e) => { e.stopPropagation(); openDetailedCard(item); }} >
                                                    //     <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="30px" fill="#001E3A"><path d="M480-528 296-344l-56-56 240-240 240 240-56 56-184-184Z" /></svg>
                                                    // </div>
                                                }
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )
                    )
                ) : (
                    <div className="loading">Loading...</div>
                )}
                <div
                    className="cookies"
                    style={{
                        width: "100vw",
                        textAlign: "center",
                    }}
                >
                    we use Cookies*
                </div>
                <br />
                <br />
                <br />
                <br />
                <br />
            </>
        </div>
    );
};

export default BestMenu;
